import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AccordionItemWithCheckboxes from './AccordionItemWithCheckboxes';

import { setAccordionState } from '@sm/store/accordionSlice';

const AccordionWithCheckboxes = ({
  id,
  filters,
  selectedOptions,
  handleCheckboxChange
}) => {
  const dispatch = useDispatch();
  const openIndex = useSelector((state) => state.accordion[`${id}OpenIndex`]);

  const [openItem, setOpenItem] = useState(openIndex);

  const toggleItem = useCallback((index) => {
    const nextValue = openIndex === index ? null : index;

    setOpenItem(nextValue);
    dispatch(setAccordionState({ [`${id}OpenIndex`]: nextValue }));
  }, [dispatch, id, openIndex]);

  useEffect(() => {
    if (openItem !== openIndex) {
      setOpenItem(openIndex);
    }
  }, [openItem, openIndex]);

  return (
    <div className="custom-accordion">
      {filters.map((filter, index) => {
        const idx = index.toString();
        return (
          <AccordionItemWithCheckboxes
            key={ filter.id }
            filter={ filter }
            selectedOptions={ selectedOptions[filter.id] || [] }
            onCheckboxChange={ handleCheckboxChange }
            isOpen={ openItem === idx }
            onToggle={ () => toggleItem(idx) }
          />
        );}
      )}
    </div>
  );
};

export default AccordionWithCheckboxes;
